import { defineMessages } from 'react-intl-next';

export const messages: {
	toolbarName: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	toolbarName: {
		id: 'floating-toolbar.common.toolbar-name',
		defaultMessage: 'Bulk actions',
		description: 'The text will show when the toolbar is focused',
	},
});
